<template>
  <div>
    <v-switch
      v-if="
        (this.ageClassLengthOptions !== null) || ['standardised_mortality_rate_by_age','standardised_mortality_rate_by_age_and_sexe'].includes(this.measures)
      "
      v-model="ageFilter"
      :label="$i18n.t('select_age_groups')"
      @change="ageChoice()"
    ></v-switch>
    <template
      v-if="
        this.ageFilter &&
          this.ageOptions !== null &&
          this.age
      "
      ><v-row dense>
        <v-checkbox
          v-model="selectedAge"
          v-for="(option, i) in translateAge"
          :key="i"
          :label="option.text"
          :value="option.value"
          class="shrink mr-6 mt-0"
        />
      </v-row>
      <v-row no-gutters>
        <v-checkbox
          dense
          v-model="allSelected"
          :label="$i18n.t('select_all')"
          @click="selectAll()"
        ></v-checkbox>
      </v-row>
    </template>
   </div>
</template>
<script>
import axios from "axios";
export default {
  name: "AgeForm",
  components: {},
  props: {
    agregration_1_24: {
      type: Boolean,
      required: false,
      default: false
    },
    measures: {
      type: String,
      required: true,
      default: "raw_number_of_death"
    }
  },
  data: function() {
    return {
      age: false,
      ageFilter: false,
      ageClassLengthOptions: [],
      selectedAgeClassLength: [],
      ageOptions: [],
      selectedAge: [],
      allSelected: false,
      error: null
    };
  },
  computed: {
    translateAge: function() {
      const val = this;
      const res = this.ageOptions.map(function(e) {
        console.log("In entrance", e);
        if (e !== undefined) {
          return {
            value: e,
            text: val.$i18n.t("age_modality." + e)
          };
        } else {
          return {
            value: e,
            text: e
          };
        }
      });
      return res;
    },
    translateAgeClassLength: function() {
      if (this.ageClassLengthOptions.length === undefined) {
        return [];
      } else {
        const val = this;
        const res = this.ageClassLengthOptions.map(function(e) {
          return {
            value: e,
            text: val.$i18n.tc(e, 0)
          };
        });
        return res;
      }
    }
  },
  methods: {
    availableAgeClass: function() {
      console.log("availableAgeClass()");
      this.error = false;
      axios
        .get("bcmd/r/age_class_length", {
          params: {
            measures: this.measures
          }
        })
        .then(response => {
          this.ageClassLengthOptions = response.data;
          this.selectedAgeClassLength = this.ageClassLengthOptions[0];
        })
        .catch(() => {
          this.error = true;
        });
    },
    availableAge: function() {
      console.log("availableAge()");
      axios
        .get("bcmd/r/age_classes", {
          params: {
            measures: this.measures,
            highest_class: "95p",
            class_length: this.selectedAgeClassLength,
            agregration_1_24: this.agregration_1_24
          }
        })
        .then(response => {
          this.ageOptions = response.data;
          if (this.age) {
              this.selectedAge = response.data;
          } else {
            this.selectedAge = [];
          }
          this.ageFilter = false;
        })
        .catch(() => {
          this.error = true;
        });
    },
    ageChoice: function() {
      console.log("ageChoice()");
      if (
        this.selectedAge === null ||
        this.ageOptions === null ||
        this.selectedAge.length !== this.ageOptions.length
        ) {
        this.allSelected = false;
        } else {
        this.allSelected = true;
      }
      this.$emit("update-age", {
        age: this.age,
        selectedAgeClassLength: this.selectedAgeClassLength,
        ageFilter: this.ageFilter,
        selectedAge: this.selectedAge
      });
      return true;
    },
    selectAll: function() {
      if (this.allSelected) {
        this.selectedAge = this.ageOptions;
        } else {
        this.selectedAge = [];
      }
    },
    measuresReset: function() {
      this.availableAgeClass();
      this.availableAge();
      this.selectedAge = [];
      },
    ageInfoReset: function() {
      console.log("ageInfoReset : modif selectedAge et ageFilter");
      if (this.age) {
        this.selectedAge = this.ageOptions;
      } else {
          this.selectedAge = [];
      }
    },
    ageFilterReset: function() {
      console.log("ageFilterReset : modif selectedAge");
      if (this.ageFilter) {
        this.selectedAge = this.ageOptions;
      } else {
        this.selectedAge = [];
    }
    }
  },
  beforeMount() {
    this.availableAgeClass();
  },
  watch: {
    measures: function() {
      console.log("watch measures : this.measuresReset()");
      this.measuresReset();
    },
    age: function() {
      console.log("watch age : this.ageInfoReset()");
      this.ageInfoReset();
    },
    selectedAgeClassLength: function() {
      console.log("watch selectedAgeClassLength : this.availableAge()");
      this.availableAge();
    },
    ageFilter: function() {
      console.log("watch Filter : this.ageFilterReset");
      this.ageFilterReset();
      this.age = this.ageFilter 
    },
    selectedAge: function() {
      console.log("watch selectedAge : this.ageChoice()");
      this.ageChoice();
    }
  }
};
</script>
